import {profGral} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';

function useLoadProfGral() {
  return useLoad(profGral, 'iD_ProfGral', {});
}

export default useLoadProfGral;
